module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_8-26fb6c0fd973df11b84843a712084603.jpeg";